import './index.css'
import { useState } from 'react'
import { X } from 'lucide-react'
import type { Transaction } from '../../types'

interface AmortizeModalProps {
  transaction: Transaction | null
  onConfirm: (count: number) => void
  onClose: () => void
}

export default function AmortizeModal({ transaction, onConfirm, onClose }: AmortizeModalProps) {
  const [count, setCount] = useState(1)

  if (!transaction) return null

  const idx = transaction.installment_index ?? 1
  const total = transaction.installment_count ?? 1
  const remaining = total - idx

  if (remaining <= 0) return null

  function handleConfirm() {
    if (count < 1 || count > remaining) return
    onConfirm(count)
  }

  return (
    <div className="bc-amortize-overlay" onClick={onClose}>
      <div className="bc-amortize" onClick={e => e.stopPropagation()}>
        <div className="bc-amortize__header">
          <h3 className="bc-amortize__title">Adiantar parcelas</h3>
          <button className="bc-amortize__close" aria-label="Fechar" onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        <div className="bc-amortize__body">
          <p className="bc-amortize__info">
            <strong>{transaction.title}</strong> — parcela <strong>{idx}/{total}</strong>.
            {' '}Há <strong>{remaining}</strong> {remaining === 1 ? 'parcela futura' : 'parcelas futuras'} que podem ser adiantadas para este mês.
          </p>

          <div className="bc-amortize__field">
            <label htmlFor="amortize-count">Quantas parcelas deseja adiantar?</label>
            <input
              id="amortize-count"
              type="number"
              className="bc-input"
              min={1}
              max={remaining}
              value={count}
              onChange={e => setCount(Math.max(1, Math.min(remaining, Number(e.target.value))))}
            />
          </div>
        </div>

        <div className="bc-amortize__footer">
          <button className="bc-btn bc-btn--ghost bc-btn--sm" onClick={onClose}>Cancelar</button>
          <button className="bc-btn bc-btn--primary bc-btn--sm" onClick={handleConfirm}>
            Adiantar {count} {count === 1 ? 'parcela' : 'parcelas'}
          </button>
        </div>
      </div>
    </div>
  )
}
